import React, { PropsWithChildren } from 'react';
import style from './Page.module.less';
import classnames from 'classnames';

type PageType = {
  className?: string;
};

const Page = (props: PropsWithChildren<PageType>) => {
  const { className, children } = props;
  return <div className={classnames([style.content, className])}>{children}</div>;
};

export default Page;
